import { render, staticRenderFns } from "./Sets.vue?vue&type=template&id=25835651&scoped=true"
import script from "./Sets.vue?vue&type=script&lang=ts&setup=true"
export * from "./Sets.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Sets.vue?vue&type=style&index=0&id=25835651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25835651",
  null
  
)

export default component.exports